// disable console log if env is production
if (process.env.NODE_ENV !== 'development') {
  window.console = window.console || {}
  console.log = () => {}
}
